import React, { Component, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Button,
  Grid,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Drawer
} from "@material-ui/core";
import { PostApi, GetApi } from "../../../js_assets/Network";
import moment from "moment";
import SearchIcon from "@material-ui/icons/Search";
import AppAdminContainer from "../AppAdminContainer";
import EditScheduleForm from './EditScheduleForm'
import { useForm } from "react-hook-form";


const useStyles = makeStyles(theme => ({
  ButtonSearch: {
    backgroundColor: "#007bff",
    color: "white",
    "&:hover": {
      background: "#007bff",
    },
  },

  ButtonGuide: {
    backgroundColor: "#74cbc4",
    color: "white",
    "&:hover": {
      background: "#74cbc4",
    },
    // margin: theme.spacing.unit,
    padding: "2px",
  },
  row: {
    color: "white"
  }

}));

function AdminSubscriptionSchedule(props) {

  const classes = useStyles();

  const [User_Subscription_List, setUser_Subscription_List] = useState([]);
  const [List_Schedule_All_Trainer, setList_Schedule_All_Trainer] = useState([]);
  const [List_Discount_Code, setList_Discount_Code] = useState([]);
  const [IsSearching, setIsSearching] = useState(false);
  const [IsSearchingUser, setIsSearchingUser] = useState(false);

  const [IsSaveUserSchedule, setIsSaveUserSchedule] = useState(false);
  const [UserInfo, setUserInfo] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [query, setQuery] = useState(null);
  const [EditSchedule, setEditSchedule] = useState(false);
  const [selectedEditSchedule, setSelectedEditSchedule] = useState(null);



  const Admin_Info = JSON.parse(localStorage.getItem("Admin_Info"))

  const { getValues, setValue, handleSubmit, errors, register, watch } = useForm({ defaultValues: {}, });
  const values = watch();
  useEffect(() => {
    register("userName", { required: true });
    register("UserNameAndEmail", { required: true });
    register("selecedDiscountCodeId", { required: true });
    register("subscription_Price", { required: true });
    register("payment_Transaction_Id", { required: true });
    register("schedule_Duration", { required: true });
    register("original_Subscription_Price", { required: true });






  }, []);


  console.log("values selecedDiscountCodeId", values.selecedDiscountCodeId)

  useEffect(() => {
    Promise.all([
      GetApi(
        `/api/Admin/Get_List_Schedule_All_Trainer`,
        Admin_Info.jwT_Token_Admin
      ),
      GetApi(
        `/api/Admin/Get_Discount_Codes/${Admin_Info.admin_Id}`,
        Admin_Info.jwT_Token_Admin
      ),
    ]).then((rep) => {

      setList_Schedule_All_Trainer(rep[0])
      setList_Discount_Code(rep[1])

    });

  }, []);



  function Search_User_SubscriptionSchedule() {


    setIsSearching(true)

    setUser_Subscription_List([])
    PostApi(
      `/api/admin/Get_User_Subscription/${Admin_Info.admin_Id}`,
      { query: query },
      Admin_Info.jwT_Token_Admin
    ).then((rep) => {
      if (rep.status) {

        setUser_Subscription_List(rep.result)
      }
      setIsSearching(false)
    });
  };

  function Search_User_info() {

    setIsSearchingUser(true)
    setUserInfo(null)

    PostApi(
      `/api/admin/GetUser/${Admin_Info.admin_Id}`,
      { query: query },
      Admin_Info.jwT_Token_Admin
    ).then((rep) => {
      if (rep.status) {


        setUserInfo(rep.result);

        setValue("UserNameAndEmail", rep.result.userName + "-" + rep.result.user_Email);

        setIsSearchingUser(false)
      }

    })
  }

  function Delete_Discount_Code(ID) {

    GetApi(
      `/api/Admin/Delete_SubscriptionSchedule/${ID}/${Admin_Info.admin_Id}`,
      Admin_Info.jwT_Token_Admin
    ).then(() => {
      alert("تم الحدف");

      let newUser_Subscription_List = User_Subscription_List;

      newUser_Subscription_List = newUser_Subscription_List.filter(
        (e) => e.subscription_Schedule_Id !== ID
      );



      setUser_Subscription_List(newUser_Subscription_List)
    });
  };

  function handelonChangeSelecedSchedule(e) {
    console.log("e", e.target.value);
    let selectFollowUpScheduleId = e.target.value;

    let reuslt = List_Schedule_All_Trainer.filter(
      (e) => e.followUp_Schedule_Id == selectFollowUpScheduleId
    );

    if (reuslt.length != 0) {

      setSelectedSchedule(reuslt[0])
      setValue("subscription_Price", reuslt[0].followUp_Schedule_Price);
    }
  };

  function handelonChangeSelecedDiscount_Code(e) {
    let selectDiscount_Code = e.target.value;

    let reuslt = List_Discount_Code.filter(
      (e) => e.discount_Code_Id == selectDiscount_Code
    );

    if (reuslt.length !== 0) {

      setValue("selecedDiscountCodeId", reuslt[0].discount_Code_Id);

    }
  };

  function handelEditSchedule(data) {


    setSelectedEditSchedule(data)
    setEditSchedule(true)

  }

  function Save_Subscription_Schedule() {


    if (selectedSchedule !== null && UserInfo !== null) {
      setIsSaveUserSchedule(true)
      let model = {
        Subscription_Is_Free: false,
        UserID: UserInfo.userId,
        discount_Code_Id: values.selecedDiscountCodeId ? parseInt(values.selecedDiscountCodeId) : 0,
        followUp_Schedule_Id: parseInt(selectedSchedule.followUp_Schedule_Id),
        original_Subscription_Price: parseFloat(values.original_Subscription_Price),
        payment_Transaction_Id: values.payment_Transaction_Id,
        subscription_Current: true,
        subscription_Price: parseFloat(values.subscription_Price),
        trainer_Id: selectedSchedule.trainer_Id,
      };

      PostApi(`/api/trainer/Save_Subscription_Schedule/${parseInt(values.schedule_Duration)}`,
        model,
        null
      ).then(() => {
        GetApi(
          `/api/chat/GetConversionID/${selectedSchedule.trainer_Id}/${UserInfo.userId}`,
          null
        ).then(() => {

          setIsSaveUserSchedule(false)
          alert("تم اضافة الجدول");
        });
      });
    }
  };



  let optionItems_schedule =
    List_Schedule_All_Trainer.length !== 0 &&
    List_Schedule_All_Trainer.map((data) => (
      <option
        value={data.followUp_Schedule_Id}
        key={data.schedule_Package_Type_Id}
      >
        {data.trainer_Name +
          " - " +
          data.followUp_Schedule_Name +
          " - " +
          data.schedule_Package_Type_Name}
      </option>
    ));

  let optionItems_Discount_Code =
    List_Discount_Code.length !== 0 &&
    List_Discount_Code.map((data) => (
      <option value={data.discount_Code_Id} key={data.discount_Code_Id}>
        {data.advertiser_Name + " - " + data.coupon_Code}
      </option>
    ));


  return (
    <AppAdminContainer Title={"الاشتراكات والجداول"}>
      <div className="container">

        <div className="center">
          <label> تسجيل الاشتراك جديد للعميل</label>
        </div>
        <div className="center">

          <input
            placeholder="رقم الجوال  او الايميل"
            name="queryUserInfo"
            onChange={e => setQuery(e.target.value)}
          />

          <button
            disabled={IsSearching}
            onClick={() => Search_User_info()}
            size="small"
            variant="contained"
            color="secondary"
            style={{ paddingRight: 10 }}
          >
            {IsSearching ? <CircularProgress size={20} /> : <SearchIcon style={{ color: "white" }} />}
          </button>

        </div>


        <div >

          <input
            disabled

            placeholder="العميل"
            name="UserNameAndEmail"
            value={values.UserNameAndEmail}
            required
          />


          <select

            name="selecedSchedule"
            onChange={(e) => handelonChangeSelecedSchedule(e)}
            required
          >
            {optionItems_schedule}
          </select>


          <select

            name="selecedDiscountCodeId"
            onChange={(e) => handelonChangeSelecedDiscount_Code(e)}
            required
          >
            {optionItems_Discount_Code}
          </select>


          <input

            placeholder="سعر الاشتراك "
            name="subscription_Price"
            value={values.subscription_Price}
            onChange={e => setValue("subscription_Price", e.target.value)}
            required
          />


          <input

            placeholder="عدد الايام"
            name="schedule_Duration"
            value={values.schedule_Duration}
            onChange={e => setValue("schedule_Duration", e.target.value)}
            required
          />



          <input

            placeholder="السعر قبل الخصم "
            name="original_Subscription_Price"
            value={values.original_Subscription_Price}
            onChange={e => setValue("original_Subscription_Price", e.target.value)}
            required
          />

          <input

            placeholder="رقم عملية الدفع "
            name="payment_Transaction_Id"
            value={values.payment_Transaction_Id}
            onChange={e => setValue("payment_Transaction_Id", e.target.value)}
            required
          />

        </div>

        <div className="center"  >
          <button
            disabled={IsSaveUserSchedule}
            onClick={() => Save_Subscription_Schedule()}


          >
            {IsSaveUserSchedule ? (
              <CircularProgress size={20} />
            ) : (
              "حفظ الاشتراك "
            )}
          </button>
        </div>
        <hr />
        <br />
        <div >
          <div className="center">
            <input
              placeholder="رقم الجوال  او الايميل"
              name="query"
              onChange={e => setQuery(e.target.value)}
            />
          </div>
          <div className="center">
            <button
              disabled={IsSearching}
              onClick={() => Search_User_SubscriptionSchedule()}

            >
              {IsSearching ? <CircularProgress size={15} /> : <SearchIcon style={{ color: "white" }} />}
            </button>
          </div>
          <br />
          <hr />
          <br />
          {User_Subscription_List.length !== 0 && (
            <div className="center">
              <Table >
                <TableHead >
                  <TableRow >
                    <TableCell > المشترك </TableCell>
                    <TableCell > الجوال </TableCell>
                    <TableCell> المدرب </TableCell>
                    <TableCell >اسم الجدول </TableCell>
                    <TableCell > سعر الاشتراك</TableCell>
                    <TableCell > سعر قبل الخصم</TableCell>
                    <TableCell > تاريخ الاشتراك </TableCell>
                    <TableCell > تاريخ الانتهاء </TableCell>
                    <TableCell > حذف الاشتراك </TableCell>
                    <TableCell > تعديل الاشتراك </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {User_Subscription_List.map((code, index) => {
                    return (
                      <TableRow>
                        <TableCell>{code.userName}</TableCell>
                        <TableCell>{code.user_Phone}</TableCell>
                     
                        <TableCell>{code.trainer_Name}</TableCell>
                        <TableCell>{code.schedule_Package_Type_Name}</TableCell>
                        <TableCell>{code.subscription_Price}</TableCell>
                        <TableCell>
                          {code.original_Subscription_Price}
                        </TableCell>
                        <TableCell>
                          {moment(code.subscription_Date).format(
                            "YYYY-MM-DD"
                          )}
                        </TableCell>
                        <TableCell>
                          {moment(code.subscription_End).format("YYYY-MM-DD")}
                        </TableCell>
                        <TableCell>
                          {
                            <button
                              style={{ borderColor: "red", color: "red" }}
                              onClick={() => {
                                if (
                                  window.confirm("هل متاكد انك تبغى تحدف  ؟؟")
                                )
                                  Delete_Discount_Code(
                                    code.subscription_Schedule_Id
                                  );
                              }}
                            >
                              <span className="span12px"> احذف</span>
                            </button>
                          }
                        </TableCell>
                        <TableCell>{<button onClick={() => handelEditSchedule(code)}   >
                          <span className="span12px"> تحديث</span>
                        </button>}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          )}
        </div>

        <Drawer
          anchor="left"
          open={EditSchedule}
          onClose={() => setEditSchedule(false)}
        >
          {
            selectedEditSchedule != null &&

            <EditScheduleForm data={selectedEditSchedule} />


          }

        </Drawer>
      </div>
    </AppAdminContainer >
  );
}


export default AdminSubscriptionSchedule;
